/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from '@/components/cusPagination.vue';
import { fileEcho, goodsNotReviewedList, shopDetail } from '../../api/url';
import { detailUrl } from '../../config/config';
export default {
  components: {
    CusPagination
  },
  data() {
    return {
      callback: detailUrl + 'details?id=', //复制地址详情
      fileEcho: fileEcho, //openFile,//fileUpLoca
      goodsName: '', //商品名称
      goodsID: '', //商品id
      goodsShop: '', //所属店铺
      moneySectionVal: '', //价格区间
      moneySectionOption: [
        { label: '0-1000元', value: '0,1000' },
        { label: '1001-2000元', value: '1001,2000' },
        { label: '2001-3000元', value: '2001,3000' },
        { label: '3001-4000', value: '3001,4000' },
        { label: '4001-5000', value: '4001,5000' },
        { label: '5001以上', value: '5001' }
      ],
      transportVal: '', //运送方式
      transportOption: [
        { value: 'EXPRESS', label: '快递' },
        { value: 'ONLINE', label: '线上' },
        { value: 'DOWNLOAD', label: '下载' }
      ],
      goodsStateVal: '', //商品状态
      goodsStateOption: [
        { value: 'ON_SALE', label: '出售中' },
        { value: 'HALT_SALE', label: '下架' },
        { value: 'VIOLATION_HALT_SALE', label: '违规下架' },
        { value: 'FOR_SALE', label: '上架' },
        { value: 'RESERVE', label: '待上架' },
        { value: 'CREATE', label: '新建' }
      ],
      creationTime: [], //创建时间
      tableData: [], //表格数据
      page: 1,
      size: 10,
      count: 0
    };
  },
  // 自定义方法
  methods: {
    //重置
    resetBtn() {
      this.goodsName = ''; //商品名称
      this.goodsID = ''; //商品id
      this.goodsShop = ''; //所属店铺
      this.moneySectionVal = ''; //价格区间
      this.transportVal = ''; //运送方式
      this.goodsStateVal = ''; //商品状态
      this.creationTime = []; //创建时间
      this.page = 1;
    },
    //编辑商品
    editGoods(id) {
      this.$router.push({ path: '/goodsDetail', query: { id: id, type: 'Not' } });
    },
    //获取列表数据
    getDataList() {
      let data = {
        name: this.goodsName, //商品名称
        unionId: this.goodsID, //商品id
        storeName: this.goodsShop, //所属店铺
        price: this.moneySectionVal, //价格区间
        deliveryMode: this.transportVal, //运送方式
        state: this.goodsStateVal, //商品状态
        pageNumber: this.page,
        pageSize: this.size,
        auditState: 'STATE_CHECK_PENDING'
      };
      if (this.creationTime != null && this.creationTime != '') {
        data.createdDate = this.creationTime.length == 0 ? '' : this.creationTime[0] + ' 00:00:00,' + this.creationTime[1] + ' 00:00:00';
      }
      this.$ajax.get(goodsNotReviewedList, data).then(
        res => {
          console.log(res);
          this.count = res.data.total;
          this.tableData = res.data.rows;
        },
        err => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: 'error',
            center: true,
            duration: 3000
          });
        }
      );
    }
  },
  // 数据观察监听
  watch: {
    $route(to, from) {
      //监听路由是否变化
      console.log(to, from);
      this.$router.go(0);
    },
    page(newData, oldData) {
      this.getDataList();
    },
    size(newData, oldData) {
      this.page = 1;
      this.getDataList();
    }
  },
  // 计算数据
  computed: {
  },
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {},
  // 组件挂载完成之前
  beforeMount() {
    if (this.$route.query.shopId != undefined) {
      this.$ajax.get(shopDetail(this.$route.query.shopId), { id: this.$route.query.shopId }).then(
        res => {
          console.log(res);
          this.goodsShop = res.data.name;
          this.getDataList();
        },
        err => {
          console.log(err);
        }
      );
    } else {
      this.getDataList();
    }
  },
  // 组件挂载完成
  mounted() {},
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {}
};
